export function createMarkup(dirty) {
  return { __html: dirty };
}
